module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQBAMAAAB8P++eAAAAMFBMVEUAAAD/VEz9Vkz9VU39VUz8VU38VU3/VUr/WEj9VUz9VUz8VU39VUz/UFD/VU39Vk0inXO+AAAAD3RSTlMAP3+g8MBgMCDg0LCQEFCGgX3DAAAA50lEQVRIx+3WLU5DURCG4RcIpYbmXgw4CB6qUdcR3GUBCDwCkCjKGlgASyg7gB3QEDZC4EL/0mlqas/rmjTn0SPOnEm+GWifRdJzD+iG8AeboVzzGMqQKpQpL6E0hEQdypi3UH64DeWb7VBe2e2rpgfwKdoZHQFslEl3ZNn629k7TjgtADoifX5PgA+VKANaoVzyFcrMZs+Erow9Wxi2sLFbYWrz8YJ2LRcSDyGcA9ykh33VI8uypfsyYZ+FVl8kTwFU7uJiK5R3DkP599devaqLtKGSb9Rd63/0k6EjZj0pWHgqEw6AOYfL39zjKUbHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.png
// module id = 01ru
// module chunks = 16